<template>
    <modal
        :header="$t('header')"
        name="tourModal"
        isLarge="true">
        <div class="envelope-guide">
            <div class="envelope-guide__wrapper" v-if="showSlideShow">
            <ul class="envelope-guide__slider" :style="listWidth">
                <li>
                <EnvelopeGuidePage1 />
                <p>{{ $t('envelopeGuide.documentDetails') }}</p>
                </li>
                <li>
                <EnvelopeGuidePage2 />
                <p>{{ $t('envelopeGuide.progressBar') }}</p>
                </li>
                <li>
                <EnvelopeGuidePage3 />
                <p>{{ $t('envelopeGuide.gotQuestions') }}</p>
                </li>
                <li>
                <EnvelopeGuidePage4 />
                <p>Want to see some more document details, here you go! Also download the PDF version from here for bedtime reading.</p>
                </li>
                <li>
                <EnvelopeGuidePage5 />
                <p>{{ $t('envelopeGuide.legality') }}</p>
                </li>
                <li>
                <EnvelopeGuidePage6 />
                <p>{{ $t('envelopeGuide.fieldsRemaining') }}</p>
                </li>
                <li>
                <EnvelopeGuidePage7 />
                <p>{{ $t('envelopeGuide.unsureWhereNextFieldIs') }}</p>
                </li>
            </ul>
            </div>
            <div class="envelope-guide__welcome" v-else>
            {{ $t('envelopeGuide.unsureWhatToDoNext') }}
            </div>
            <div class="envelope-guide__slider__buttons" v-if="showSlideShow">
            <a class="envelope-guide__slider__prev" @click="prev" v-if="listPos > 0">
                <icon name="chevron-left" height="20"></icon>
            </a>
            <a class="envelope-guide__slider__next" @click="next" v-if="listPos < (listCount-1)">
                <icon name="chevron-right" height="20"></icon>
            </a>
            </div>
        </div>
        <template slot="modalButtons" slot-scope="props">
            <app-button
                :text="showModalButtons ? $t('functional.noThanks') : $t('functional.close')"
                iconName="times"
                :action="props.close"></app-button>
            <app-button
                :text="$t('functional.showMe')"
                iconName="chevron-right"
                :action="startSlideShow"
                classList="float-right button--cta"
                v-if="showModalButtons"></app-button>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal'
import AppButton from '@/components/AppButton'
import EnvelopeGuidePage1 from '@/components/tour/page-1'
import EnvelopeGuidePage2 from '@/components/tour/page-2'
import EnvelopeGuidePage3 from '@/components/tour/page-3'
import EnvelopeGuidePage4 from '@/components/tour/page-4'
import EnvelopeGuidePage5 from '@/components/tour/page-5'
import EnvelopeGuidePage6 from '@/components/tour/page-6'
import EnvelopeGuidePage7 from '@/components/tour/page-7'

/* eslint no-param-reassign: ["error", { "props": false }] */
export default {
  name: 'envelope-guide',
  components: {
    Modal,
    AppButton,
    EnvelopeGuidePage1,
    EnvelopeGuidePage2,
    EnvelopeGuidePage3,
    EnvelopeGuidePage4,
    EnvelopeGuidePage5,
    EnvelopeGuidePage6,
    EnvelopeGuidePage7
  },
  data () {
    return {
      showSlideShow: false,
      listItemWidth: 0,
      listItemStyle: 0,
      listWidth: 0,
      listPos: 0,
      listCount: 0,
      listItems: [],
      showModalButtons: true
    }
  },
  mounted () {
    this.listItemWidth = this.$el.clientWidth
  },
  updated () {
    this.renderSlideShow()
  },
  watch: {
    listPos () {
      this.renderSlideShow()
    }
  },
  methods: {
    prev () {
      this.listPos -= 1
    },
    next () {
      this.listPos += 1
    },
    renderSlideShow () {
      this.listItems = Array.from(this.$el.getElementsByTagName('li'))
      this.listCount = this.listItems.length
      this.listItems.forEach((item) => {
        item.style.width = `${this.listItemWidth}px`
      })
      const width = this.listItemWidth * this.listCount
      const marginLeft = this.listItemWidth * this.listPos
      this.listWidth = `width: ${width}px; transform: translate3d(-${marginLeft}px, 0, 0);`
    },
    startSlideShow () {
      this.showSlideShow = true
      this.showModalButtons = false
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .envelope-guide
    &__welcome
      font-size: 18px
      line-height: 1.5
    &__wrapper
      overflow: hidden
    &__slider
      padding: 0
      margin: 0
      list-style: none
      text-align: center
      line-height: 1.5
      font-size: 20px
      font-weight: bold
      transition: all .25s ease
      li
        float: left
        padding: $spacing-base
        svg:not(.fa-icon)
          height: auto
          width: 100%
      img
        min-height: 250px
      &__buttons
        position: absolute
        width: 100%
        top: 50%
        a
          position: absolute
          background: #fff
          border-radius: 30px
          color: $color-main-dark
          padding: $spacing-small $spacing-base
          line-height: 0
          box-shadow: 0 5px 20px -5px $color-grey-dark
          cursor: pointer
          &:hover
            background: $color-main
            color: #fff
          .fa-icon
            margin: 0
      &__prev
        left: -56px - $spacing-base
      &__next
        right: -26px - $spacing-base
  //responsive
  @media screen and (max-width: $screen-size-large)
    .envelope-guide
      &__slider
        img
          min-height: 0
        &__buttons
          width: 0%
          bottom: 57px
          right: 60px
          top: initial
</style>
